import { atom } from "recoil";
import { SupportTicket } from "../../../globals/interfaces";

export const supportTicketsState = atom<Array<SupportTicket>>({
    key: 'supportTickets',
    default: []
});

export const selectedTicketIdState = atom<number>({
    key: 'selectedTicketId',
    default: undefined
});

export const supportRequestModalState = atom<boolean>({
    key: 'supportRequestModal',
    default: false
});

export const assignableUsersState = atom<Array<{ email: string, unit: string }>>({
    key: 'assignableUsers',
    default: []
});


